import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Tab, Tabs, Form } from "react-bootstrap";
import * as style from "./style.module.scss";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import sliderLeftArrow from "../../../images/HyperLedger/leftArrow.svg";
import sliderRightArrow from "../../../images/HyperLedger/rightArrow.svg";

const SuccessStories = ({
  strapiData,
  homeSuccess,
  web3SuccessStories,
  tokenSuccessStories,
  pricingSuccess,
  nftMarketSuccessStories,
  AiDevSuccesStories,
  MlDevSuccesStories,
}) => {
  //
  const [value] = useState("All");
  const [status, setStatus] = useState([]);
  const swiperReference = useRef();
  //
  console.log(strapiData);
  const settings = {
    className: "successSlider",
    // slidesPerView: 1,
    // slidesToScroll: 1,
    // lazyLoad: true,
    // autoplay: false,
    // swipeToSlide: true,
    speed: 3000,
    // autoplaySpeed: 8000,
    // cssEase: "linear",
    // pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          // slidesPerView: 1,
          centerPadding: 0,
          centerMode: false,
          // slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          // slidesPerView: 1,
          // slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          // slidesPerView: 1,
          // slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          // slidesPerView: 1,
          // slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };
  //
  const tabTitles = [
    {
      title: "All",
      eventId: "All",
    },
  ];
  for (const tabTitle of strapiData.cards) {
    if (!tabTitles.some((item) => item.title === tabTitle.subTitle)) {
      tabTitles.push({
        title: tabTitle.subTitle,
        eventId: tabTitle.subTitle,
      });
    }
  }
  useEffect(() => {
    slider(value);
  }, []);
  const slider = (e) => {
    const mobileSuccessStories =
      e === "All"
        ? strapiData.cards
        : strapiData.cards.filter((f) => f.subTitle === e);
    setStatus(mobileSuccessStories);
  };
  return (
    <>
      <section
        className={`SuccessStories ${style.SuccessStories} ${
          homeSuccess && style.homeSuccessSection
        } ${tokenSuccessStories && style.tokenSuccessSection} ${
          pricingSuccess && style.pricingSuccessSection
        } ${nftMarketSuccessStories ? style.nftMarketSuccessStories : ""} ${
          AiDevSuccesStories ? style.AiDevSuccesStories : ""
        }`}
      >
        <div className={style.SuccessStoriesAnim}>
          <div
            className={`${
              web3SuccessStories ? "rightGreenCircle" : "rightCircle"
            } ${
              web3SuccessStories ? style.rightGreenCircle : style.rightCircle
            } ${AiDevSuccesStories ? "leftMetaverseCircle" : ""} ${
              AiDevSuccesStories || MlDevSuccesStories ? style.Aileftcircle : ""
            }`}
          />
          <Container className={style.heading_container}>
            <h2
              className={`${style.heading} ${
                web3SuccessStories && style.web3SuccessHeading
              } ${nftMarketSuccessStories ? style.nftMarketPlaceHeading : ""}
                ${AiDevSuccesStories ? style.AiDevSuccesStoriesHeading : ""}`}
            >
              Success Stories
            </h2>
          </Container>
          <Container
            className={`${style.container} ${
              nftMarketSuccessStories ? style.nftMarketContainer : ""
            }`}
          >
            <Row className={`px-0 ${style.row}`}>
              <Col
                className={`px-0 ${style.tabSuccessStories} ${
                  nftMarketSuccessStories
                    ? style.nftMarkettabSuccessStories
                    : ""
                }`}
                lg={12}
              >
                <div className={style.categoriesSelection}>
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => slider(e.target.value)}
                  >
                    {tabTitles.map((el) => (
                      <option value={el.title} key={el.title}>
                        {el.title}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <Tabs
                  defaultActiveKey="All"
                  id="justify-tab-example"
                  className="mb-5"
                  transition={false}
                  onSelect={(e) => slider(e)}
                >
                  {tabTitles.map((d, id) => (
                    <Tab key={id} eventKey={d.title} title={d.title}></Tab>
                  ))}
                </Tabs>
                <div className={style.sliderWrapper}>
                  <Swiper
                    {...settings}
                    slidesPerView={1}
                    pagination={{
                      clickable: true,
                      type: "fraction",
                    }}
                    modules={[Pagination]}
                    onBeforeInit={(swiperSlide) => {
                      swiperReference.current = swiperSlide;
                    }}
                  >
                    {status.map((item, index) => (
                      <SwiperSlide key={index}>
                        <Row className={style.data_row}>
                          <Col
                            sm={12}
                            lg={6}
                            className={`${style.img_col} ${
                              nftMarketSuccessStories
                                ? style.nftMarketImg_col
                                : ""
                            }`}
                          >
                            <div className={style.companySiteInfo}>
                              <GatsbyImage
                                className={style.image}
                                image={getImage(item?.image1[0]?.localFile)}
                                // image={getImage(
                                //   item?.image1[0]?.localFile?.publicURL
                                // )}
                                alt={item.title}
                                placeholder={item.title}
                              />
                            </div>
                          </Col>
                          <Col sm={12} lg={6} className={style.data_col}>
                            <h3 className="fw-bolder">{item.title}</h3>
                            <div className={style.companyReview}>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: item.description.data.description,
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className={style.swiperBtnWrapper}>
                    <div
                      className={style.swiperBtn}
                      onClick={() => swiperReference.current?.slidePrev()}
                      aria-label="Previous Slide"
                    >
                      <img
                        src={sliderLeftArrow}
                        alt="sliderLeftArrow"
                        placeholder="sliderLeftArrow"
                      />
                    </div>
                    <div
                      className={style.swiperBtn}
                      onClick={() => swiperReference.current?.slideNext()}
                      aria-label="Next Slide"
                    >
                      <img
                        src={sliderRightArrow}
                        alt="sliderRightArrow"
                        placeholder="sliderRightArrow"
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default SuccessStories;
